export default __webpack_public_path__ + "static/media/pro_aim_software.885e1344.png";